export default __webpack_public_path__ + "static/media/published-apps-sell-page.6dfb80e2.png";